import React, {useContext, useState} from 'react';
import styles from './Switch.module.css';
import {Context} from "../../../index"; // Подключаем файл модульных стилей

function TextSwitcher({setChoice_bil,now,status_switch},) {
    const [selectedOption, setSelectedOption] = useState(now);
    const {store} = useContext(Context)
    const handleOptionChange = (option) => {
        if (status_switch) {


            setSelectedOption(option);
            setChoice_bil(option)
        }

    };

    return (
        <div className={styles.switchContainer}>
            <div className={`${styles.switchLabel} ${(selectedOption === 'demo' && !status_switch)?styles.disable_label:""} ${selectedOption === 'real' && styles.active}`} onClick={() => handleOptionChange('real')}>{store.dataLang["heder_bill1"]}</div>
            <div className={`${styles.switchLabel} ${(selectedOption === 'real' && !status_switch)?styles.disable_label:""} ${selectedOption === 'demo' && styles.active}`} onClick={() => handleOptionChange('demo')}>{store.dataLang["heder_bill2"]}</div>

        </div>
    );
}

export default TextSwitcher;